import './App.css';

import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Route, Routes } from 'react-router-dom';

import AnalysisContainer from './components/AnalysisContainer';
import { AppStateProvider } from './components/AppState';
import { ErrorPage } from './components/ErrorBoundary';

const App = () => {
  let Router;
  if (typeof document !== "undefined") {
    Router = require("react-router-dom").BrowserRouter;
  } else {
    Router = require("react-router-dom").StaticRouter;
  }

  return (
      <AppStateProvider>
        <HelmetProvider>
          <Router>
            <Routes>
              <Route path="/report">
                <Route path=":id" element={<AnalysisContainer />} />
              </Route>
              <Route path="/error" element={<ErrorPage />} />
            </Routes>
          </Router>
        </HelmetProvider>
      </AppStateProvider>
  )
};

export default App;
